// 获取推荐品牌商列表
export const GET_BRAND_LIST = "GET_BRAND_LIST";
// 申请合作
export const APPLY_CORP = "APPLY_CORP";


// WEBPACK FOOTER //
// ./src/store/brand/type.js